import { render, staticRenderFns } from "./preShippingBillDialog.vue?vue&type=template&id=359ba10a&scoped=true&"
import script from "./preShippingBillDialog.vue?vue&type=script&lang=js&"
export * from "./preShippingBillDialog.vue?vue&type=script&lang=js&"
import style0 from "./preShippingBillDialog.vue?vue&type=style&index=0&id=359ba10a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359ba10a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('359ba10a')) {
      api.createRecord('359ba10a', component.options)
    } else {
      api.reload('359ba10a', component.options)
    }
    module.hot.accept("./preShippingBillDialog.vue?vue&type=template&id=359ba10a&scoped=true&", function () {
      api.rerender('359ba10a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/preShippingBillDialog.vue"
export default component.exports